import {
  Box,
  Container,
  makeStyles,
} from "@material-ui/core";
import {
  HeaderWithButtons,
} from "../components-molecules";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";

import CssBaseline from "@material-ui/core/CssBaseline";
import { colours, theme } from "../constants/theme";
import { CircularProggressIndicator } from "../components-atoms";
import { textButtonHoverAndActive } from "../utils/styles/buttonStyles";
import { getSubcategoryDetailsSymbols } from "../redux/actions/getSubcategoryDetails";
import { Products } from "../components-organisms/Products";

// import { setError } from "../redux/actions/error";

export const SubcategoryDetails = (props: any) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  let { id }: { id: string } = useParams();
  useEffect(() => {
    dispatch(getSubcategoryDetailsSymbols(id));
  }, []); // eslint-disable-line

  const data = useSelector(
    (state: any) => state.SubcategoryDetailsSymbolsReducer.data
  );
  const loading = useSelector(
    (state: any) => state.SubcategoryDetailsSymbolsReducer.loading
  );

  return (
    <Box className={classes.container}>
      {loading ? (
        <CircularProggressIndicator />
      ) : (
        <>
          <CssBaseline />
          <Container className={classes.root}>
            <HeaderWithButtons
              handleBack={() => history.goBack()}
              title={data?.Name ?? "Subcategory Name"}
              smallText="Subcategory"
            >
            </HeaderWithButtons>
            <>
              <Container className={classes.detailsContainer}>
                <Products subcategoryId={id} />
              </Container>
            </>
          </Container>
        </>
      )}
    </Box>
  );
};
const useStyles = makeStyles({
  container: {
    display: "flex",
    justifyContent: "center",
  },
  imageList: {
    display: "flex",
    flexDirection: "row",
    marginTop: 15,
    paddingLeft: 0,
  },
  images: {
    width: 200,
    height: 150,
    marginRight: 10,
  },
  submitButton: {
    width: "80px",
    height: "48px",
    borderRadius: "8px",
    padding: "6px 16px",
    backgroundColor: theme.palette.primary.main,
    color: "white",
  },
  cancelButton: {
    width: "80px",
    height: "48px",
    borderRadius: "8px",
    padding: "6px 16px",
    backgroundColor: theme.palette.secondary.main,
    marginRight: "8px",
  },
  removeButton: {
    borderRadius: "8px",
    padding: "6px 16px 6px 12px",
    backgroundColor: colours.highEmphasis04,
    ...textButtonHoverAndActive
  },
  buttonIcon: {
    width: "18px",
    height: "18px",
    marginRight: 8,
  },
  cssOutlinedInput: {
    display: "flex",
    "&$cssFocused $notchedOutline": {
      border: `1px solid ${theme.palette.primary.main}`,

    },
  },

  cssFocused: {},

  notchedOutline: {
    border: "1px solid rgba(0, 0, 0, 0.12)",
  },
  printButtonText: {
    textTransform: "none",
  },
  root: {
    maxWidth: "840px",
    paddingLeft: 0,
    paddingRight: 0,
  },
  detailsContainer: {
    marginTop: "24px",
    paddingLeft: 0,
    paddingRight: 0,
  },
  printableSection: {
    display: "none",
  },
  infoTextContainer: {
    alignItems: "center",
    paddingTop: 15,
    paddingBottom: 15,
    borderBottom: "1px solid rgba(0, 0, 0, 0.08)",
  },
  uMb8: {
    marginBottom: 8,
  },
  mt12b9: {
    marginTop: 12,
    marginBottom: 9,
  },
  selectArea: { width: "100%", marginBottom: 15 },
  pt15: {
    paddingTop: 15,
  },
});
